export var DISCOUNT_TYPES = {
  FLAT: 'FLAT',
  TIERED: 'TIERED',
  FLAT_SP: 'FIXED'
};
export var COST_CENTER_SPLIT_TYPES = {
  FLAT: 'FLAT',
  GROSS: 'GROSS',
  SALES: 'SALES'
};
export var COST_CENTER_SPLIT_OPTIONS = [{
  label: __('Flat'),
  value: COST_CENTER_SPLIT_TYPES.FLAT
}, {
  label: __('Gross'),
  value: COST_CENTER_SPLIT_TYPES.GROSS
}, {
  label: __('Sales'),
  value: COST_CENTER_SPLIT_TYPES.SALES
}];
export var PRICING_TYPES = {
  FLAT: 'FLAT',
  PERCENT: 'PERCENTAGE'
};
export var APPLIED_ON_TYPES = {
  LABOR: 'LABOR',
  PARTS: 'PARTS',
  LABOR_PLUS_PARTS: 'LABOR_PLUS_PARTS',
  PART_LINE: 'PART_LINE'
};
export var FLAT_COST_CENTER_NAMES = ['SERVICE', 'PARTS'];
export var SPLIT_TOTAL_TYPES = {
  TOTAL_AFTER_TAX: 'AFTER_TAX',
  TOTAL_BEFORE_TAX: 'BEFORE_TAX'
};
export var COUPON_DEPARTMENT_TYPES = {
  SERVICE: 'SERVICE',
  PARTS: 'PARTS'
};
export var COUPON_DATA_FIELD_NAMES = {
  LABEL: 'label',
  ID: 'id',
  STATUS: 'status',
  DEPARTMENTS: 'departments',
  DEPARTMENT: 'department',
  PAYTYPES: 'payTypes',
  DESCRIPTION: 'description',
  COUPON_CODE: 'couponCode',
  OPCODES: 'opcodes',
  CALCULATED_AMOUNT: 'calculatedAmount',
  EFFECTIVE_DISCOUNT: 'effectiveDiscount',
  SERVICE_TYPES: 'serviceTypes',
  SOURCE_CODES: 'sourceCodes',
  APPLIED_ON: 'appliedOn',
  DISCOUNT_TYPE: 'discountType',
  OVERRIDDEN: 'overridden',
  OVERRIDEN_PERCENTAGE: 'overriddenPercentage',
  OVERRIDDEN_PRICING_METHOD: 'overriddenPricingMethod',
  PRICING_METHOD: 'pricingMethod',
  FROM_AMOUNT: 'fromAmount',
  TO_AMOUNT: 'toAmount',
  FLAT_AMOUNT: 'flatAmount',
  CAP_AMOUNT: 'capAmount',
  PERCENTAGE: 'percentage',
  COUPON_ID: 'couponId',
  TAX_EXEMPTED: 'taxExempted',
  TAXABLE: 'taxable',
  RO_LEVEL_ONLY: 'roLevelOnly',
  PRICING_DETAIL: 'pricingDetail'
};